import { render, staticRenderFns } from "./footprint-stat.vue?vue&type=template&id=6678842c&scoped=true"
import script from "./footprint-stat.vue?vue&type=script&lang=js"
export * from "./footprint-stat.vue?vue&type=script&lang=js"
import style0 from "./footprint-stat.vue?vue&type=style&index=0&id=6678842c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678842c",
  null
  
)

export default component.exports